import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "text" }
const _hoisted_3 = { class: "text" }
const _hoisted_4 = { class: "graph" }
const _hoisted_5 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('cv.bio2')), 1),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('cv.bio3')), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "dot",
          key: index,
          style: _normalizeStyle({
          left: item.x + 'px',
          top: item.y + 'px',
          width: item.bubble_size + 'px',
          height: item.bubble_size + 'px',
          animationDuration: item.duration,
          animationDelay: item.delay,
        })
        }, [
          _createElementVNode("img", {
            src: require(`@/assets/tshaped/${item.icon}.svg`),
            style: _normalizeStyle({ width: item.size + 'px', height: item.size + 'px' })
          }, null, 12, _hoisted_5)
        ], 4))
      }), 128))
    ])
  ]))
}